"use client";

import React from "react";
import { usePathname } from "next/navigation";
import Header from "@/components/Header";
import ShopPartnerHeader from "@/components/Header/shopPartnerHeader";

type HeaderSwitcherProps = {
  headerT: Record<string, string>;
  menuT: Record<string, string>;
};

export default function HeaderSwitcher({
  headerT,
  menuT,
}: HeaderSwitcherProps) {
  const pathname = usePathname();
  const isShopPartner =
    pathname?.startsWith("/partner-register") ||
    pathname?.startsWith("/DM-partner-register") ||
    pathname?.startsWith("/buynow-customer-campaign");

  if (isShopPartner) {
    return <ShopPartnerHeader />;
  }

  return <Header headerT={headerT} menuT={menuT} />;
}
